import { hillo } from 'hillo'
import { cloudV2Url } from '@/model/dataLayer/api/SaaS/SaaSUtils'
import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'
import GlobalConfig from '@/model/global/GlobalSettings'
import Asset from '@/model/dataLayer/api/MembershipSystem/Asset'
import dayjs from 'dayjs'

const entity = {
  operation: {
    type: IKDataEntity.Types.Integer,
    form: false,
    tableConfig: {
      overwrite: true
    }
  },
  assetId: {
    displayName: '资产',
    type: IKDataEntity.Types.Option,
    formConfig: {
      type: {
        showButton: true,
        selectItems: async () => { return await Asset.getList(true) },
        itemText: 'name',
        itemValue: 'id'
      }
    }
  },
  code: {},
  status: {
    header: false,
    displayName: 'Status'
  },
  statusDisplay: {
    type: IKDataEntity.Types.Integer,
    form: false,
    tableConfig: {
      overwrite: true
    }
  },
  maxUsageCount: {
    displayName: '最大使用次数'
  },
  usageCount: {
    displayName: '使用次数'
  },
  createAtDisplay: {
    displayName: 'createdAt'
  },
  note: {}
}

const config = {
  load: async function (filter) {
    const res = (await hillo.get(cloudV2Url + 'api/business-layers/' + GlobalConfig.blId + '/redemption-codes')).map(it => {
      it.createAtDisplay = dayjs(it.createAt).format('YYYY-MM-DD')
      return it
    })
    return res
  }
}

export default IKDataEntity.ModelFactory(entity, config)

export async function createAssetRedemption (assetId, item) {
  (await hillo.jsonPost(cloudV2Url + 'api/assets/' + assetId + '/redemption-codes', {
    ...item
  }))
}

export async function checkRedemption (code) {
  return (await hillo.get(cloudV2Url + 'api/redemption-codes/check', {
    code
  }))
}

export async function cancelRedemptionCode (code, item) {
  return (await hillo.jsonPost(cloudV2Url + 'api/redemption-codes/' + code + '/revoke', {
    ...item
  }))
}
